import { ImageSize, parseImageUrl } from "../lib/helper";
import { double } from "../models/base.model";
import { FileType } from "../models/form.model";

export default function PreviewImageContainer(props: {
  url?: string;
  style?: React.CSSProperties;
  height?: double;
  width?: double;
  isLocal?: boolean;
  children?: React.ReactNode;
  isImage?: boolean;
  urlExt?: string;
}) {
  const onClick = () =>
    window.webApp.previewDialog({
      src: props.isLocal
        ? props.url
        : parseImageUrl(props.url, ImageSize.normal),
      type: FileType.image,
      open: true,
    });

  const url = `${props.isLocal ? props.url : parseImageUrl(props.url)}${props.urlExt || ""}`;

  return props.isImage ? (
    <img
      src={url}
      alt=""
      className="pointer"
      onClick={onClick}
      width={props.width}
      height={props.height}
    />
  ) : (
    <div
      style={{
        height: props.height || 150,
        width: props.width,
        backgroundImage: `url("${url}")`,
        ...props.style,
      }}
      onClick={onClick}
      className="background-image pointer"
    >
      {props.children}
    </div>
  );
}
